import * as sharedMapConstants from '@/../shared-constants/map-constants';

export * from '@/../shared-constants/map-constants';

export { MAPBOX_ACCESS_TOKEN } from '@/config';
export const MAP_CONTAINER_ID = 'map';

export const HIGHLIGHT_PROPERTY_ZOOM = 15;

export const MAPBOX_DEFAULT_STYLE_SUBPATH = 'bjd2202/cljp048j1003301oc3o5z6if3';

// See also: https://docs.mapbox.com/api/maps/styles/
export const mapStyles = {
  [sharedMapConstants.MAPBOX_DEFAULT_STYLE]: `mapbox://styles/${MAPBOX_DEFAULT_STYLE_SUBPATH}`,
  [sharedMapConstants.MAPBOX_SATELLITE_STYLE]:
    'mapbox://styles/mapbox/satellite-streets-v11',
};

export const SIDEBAR_WIDTH = 280;
export const SCROLL_PROGRESS_BAR_WIDTH = 3;

export const DEFAULT_CIRCLE_OPACITY = 1;
export const DEAAULT_STROKE_OPACITY = 1;
export const MIN_PROPERTY_LIST_LAYER_ZOOM = 12;
export const MAX_PROPERTY_LIST_LAYER_ZOOM = 24;
export const MAX_CLUSTER_LAYER_ZOOM = MIN_PROPERTY_LIST_LAYER_ZOOM - 1;

export const SOURCES = {
  PROPERTY_LIST: 'SOURCES.PROPERTY_LIST',
  SHAPE_FILE: 'SOURCES.SHAPE_FILE',
  ZONING_FILE: 'SOURCES.ZONING_FILE',
};

export const SIDEBAR_SECTION_NAMES = {
  ADDRESS_IDENTIFICATION: 'ADDRESS_IDENTIFICATION',
  RENTAL_STRUCTURE: 'RENTAL_STRUCTURE',
  PROPERTY_LOCATION: 'PROPERTY_LOCATION',
  OCCUPANCY: 'OCCUPANCY',
  ONLINE_PLATFORMS: 'ONLINE_PLATFORMS',
  RESIDENTIAL_TYPE: 'RESIDENTIAL_TYPE',
  RENTAL_TYPE: 'RENTAL_TYPE',
};

export const SIDEBAR_SECTION_HEADERS = {
  ADDRESS_IDENTIFICATION: 'Address Identification',
  STR_LICENSE: 'STR License',
  RENTAL_STRUCTURE: 'Rental Structure',
  PROPERTY_LOCATION: 'Property Location',
  OCCUPANCY: 'Occupancy Rate',
  ONLINE_PLATFORMS: 'Online Platforms',
  RESIDENTIAL_TYPE: 'Residential Type',
  RENTAL_TYPE: 'Rental Type',
  UNIT_TYPE: 'Unit Type',
  ZONE: 'Zone',
  LISTING_VISIBILITY: 'Listing Visibility',
  ACTIVITY: 'Future Activity',
  COMPLAINTS: 'Complaints',
  VIOLATIONS: 'Violations',
  VERIFICATION: 'Verification',
};

export const INFO_BOX_SUBTITLES = {
  customer: '',
  trial: 'Free Trial Mode',
  oversight: 'Listing Data Only',
};

export const INFO_BOX_SUBTITLE_COLORS = {
  customer: '#37A3BC',
  trial: '#d3adf7',
  oversight: '#FFBB96',
};
